import React from "react";
import { Link } from "react-router-dom";
import { StarsDisplay } from "@/components/StarRating";
import { fmt } from "@/lib/api";
import { YT } from "@/constants/testIds";

export const VideoCard = ({ video }) => {
  return (
    <div data-testid={YT.videoCard}>
      <Link to={`/watch/${video.video_id}`} className="yt-thumb-wrap">
        <img src={video.thumbnail} alt={video.title} loading="lazy" />
        {video.is_short ? <span className="yt-thumb-short">SHORT</span> : null}
        <span className="yt-thumb-time">
          {video.is_short ? "0:30" : "—"}
        </span>
      </Link>
      <Link
        to={`/watch/${video.video_id}`}
        className="yt-title"
        title={video.title}
      >
        {video.title.length > 56
          ? video.title.slice(0, 56) + "…"
          : video.title}
      </Link>
      <div className="yt-meta">
        <StarsDisplay
          value={video.star_average}
          count={video.star_count}
          showCount={false}
        />
        <div>
          <b>{fmt.views(video.views)}</b> views
          <br />
          <Link to="/channel">John Casterline</Link>
          <br />
          {fmt.ago(video.published)}
        </div>
      </div>
    </div>
  );
};
